import { useTranslation } from "react-i18next";
import { Spell } from "../../../Types/TableTypes";
import SpellItemComponent from "../SpellItemComponent";

interface SpellGroupComponentProps{
    index: number,
    editMode: boolean,
    spellGroup: {
                label: string,
                hasSlotsGroup: boolean,
                hasSlotsEach: boolean,
                remainingSlots: number,
                maxSlots: number,
                list: Spell[]
            },
    updateSpellGroup: (spellGroup: {
        label: string,
        hasSlotsGroup: boolean,
        hasSlotsEach: boolean,
        remainingSlots: number,
        maxSlots: number,
        list: Spell[]
    }) => void
}

const SpellGroupComponent = (props: SpellGroupComponentProps)=> {
    const { t } = useTranslation();
    let emptySpell = {} as Spell;
        emptySpell.range = {ft: 0, mt: 0, sq: 0}; 
        emptySpell.otherRange="";
        emptySpell.components = {v: false, s: false, m: false};
        emptySpell.dc = {type: "", success: ""};
        emptySpell.areaOfEffectType =  "";
        emptySpell.areaOfEffectSize = {ft: 0, mt: 0, sq: 0};
        emptySpell.remainingSlots = 0;

    return(<>
        {props.editMode && <div className='mt-1 mb-1'>
            <div className="">
                <div className="d-flex mt-2 mb-2" >
                    <label className="form-check-label d-flex">    
                        <span>{t("spell-groupname")}&nbsp;&nbsp;</span>
                        <input 
                            value={props.spellGroup.label}
                            type="text"
                            className='form-control'
                            style={{maxWidth: "50%"}}
                            placeholder={t("spell-groupname")}
                            onChange={e => {
                                props.spellGroup.label = e.target.value;
                                props.updateSpellGroup(props.spellGroup);
                            }}
                        ></input>
                    </label>
                </div>
                <div className="d-flex mt-2 mb-2" >
                    <label className="form-check-label">
                        {t("spell-slottype")}&nbsp;&nbsp;
                        <span className="btn-group" role="group" aria-label="Basic radio toggle button group">
                            <input 
                                type="radio" 
                                className="btn-check" 
                                name={props.index+"-btnslottype-none"}
                                id={props.index+"-slottype-none"}
                                autoComplete="off" 
                                checked={!props.spellGroup.hasSlotsEach && !props.spellGroup.hasSlotsGroup} 
                                onChange={e => {
                                        if (e.target.checked){
                                            props.spellGroup.hasSlotsEach = false;
                                            props.spellGroup.hasSlotsGroup = false;
                                            props.updateSpellGroup(props.spellGroup);
                                        }
                                    }
                                }
                            />
                            <label className="btn btn-outline-primary" htmlFor={props.index+"-slottype-none"}>{t("spell-slot-none")}</label>
                            <input 
                                type="radio" 
                                className="btn-check" 
                                name={props.index+"-btnslottype-group" }
                                id={props.index+"-slottype-group"}
                                autoComplete="off" 
                                checked={props.spellGroup.hasSlotsGroup} 
                                onChange={e => {
                                        if (e.target.checked){
                                            props.spellGroup.hasSlotsEach = false;
                                            props.spellGroup.hasSlotsGroup = true;
                                            props.updateSpellGroup(props.spellGroup);
                                        }
                                    }
                                }/>
                            <label className="btn btn-outline-primary" htmlFor={props.index+"-slottype-group"}>{t("spell-slot-group")}</label>
                            <input 
                                type="radio" 
                                className="btn-check" 
                                name={props.index+"-btnslottype-each" }
                                id={props.index+"-slottype-each"}
                                autoComplete="off" 
                                checked={props.spellGroup.hasSlotsEach} 
                                onChange={e => {
                                    if (e.target.checked){
                                        props.spellGroup.hasSlotsEach = true;
                                        props.spellGroup.hasSlotsGroup = false;
                                        props.updateSpellGroup(props.spellGroup);
                                    }
                                }
                            }/>
                            <label className="btn btn-outline-primary" htmlFor={props.index+"-slottype-each"}>{t("spell-slot-each")}</label>
                        </span>
                    </label>
                </div>
                {(props.spellGroup.hasSlotsGroup || props.spellGroup.hasSlotsEach) && <div className="d-flex  mt-2 mb-2" >
                    <label className="form-check-label">
                        {t("spell-maxslots")}
                    </label>
                    &nbsp;&nbsp;
                    <input 
                        value={props.spellGroup.maxSlots}
                        type="number"
                        className='form-control'
                        style={{width: "60px", height: "40px"}}
                        onChange={e => {
                            props.spellGroup.remainingSlots = (parseInt(e.target.value));
                            props.spellGroup.maxSlots = (parseInt(e.target.value));
                            props.updateSpellGroup(props.spellGroup);
                        }}
                    ></input>
                </div>}
                <div className = "mt-2 mb-2">
                    {props.spellGroup.list && props.spellGroup.list.map((spellListItem, index2)=>{return(
                        <SpellItemComponent 
                            editMode={props.editMode}
                            isNewSpell={false}
                            spellGroup={props.spellGroup}
                            spell={props.spellGroup.list[index2]} 
                            key={"spellGroup-"+props.index+"-spell-"+index2+"-edit"}
                            updateSpell={(spell: Spell)=>{
                                props.spellGroup.list[index2] = spell;
                                props.updateSpellGroup(props.spellGroup);
                            }}
                            deleteSpell={()=>{
                                props.spellGroup.list.splice(index2, 1);
                                props.updateSpellGroup(props.spellGroup);
                            }}
                        />
                    )})}
                    <SpellItemComponent 
                        editMode={props.editMode}
                        isNewSpell={true}
                        spellGroup={props.spellGroup}
                        spell={emptySpell} key={"spellGroup-"+props.index+"-spell-new-edit"}
                        updateSpell={(spell: Spell)=>{
                            if (props.spellGroup.hasSlotsEach){
                                spell.remainingSlots = props.spellGroup.maxSlots;
                            }
                            props.spellGroup.list.push(spell);
                            props.updateSpellGroup(props.spellGroup);
                        }}
                        deleteSpell={()=>{}}
                    />

                </div>
                <div className="divider-black"></div>
            </div>
        </div>}

        {!props.editMode && <div key={"spellGroup-"+props.index+"-view"} className='mt-1 mb-1'>
            <div className="">
                <span className="d-flex" style={{width: "220px"}}>
                    <span>{props.spellGroup.label}&nbsp;</span> 
                    {props.spellGroup.hasSlotsGroup &&
                        <span className="input-group" style={{width: "114px", height: "40px"}}>
                            <input 
                                value={props.spellGroup.remainingSlots}
                                type="number"
                                className='form-control'
                                // style={{width: "70px", height: "40px"}}
                                onChange={e => {
                                    let value = parseInt(e.target.value);
                                    if (value >= 0 && value <= props.spellGroup.maxSlots){
                                        props.spellGroup.remainingSlots = value;
                                        props.updateSpellGroup(props.spellGroup);
                                    }
                                }}
                            ></input>
                            <span 
                                // style={{width: "40px", height: "40px"}} 
                                className="input-group-text"
                            >/&nbsp;{props.spellGroup.maxSlots}</span>
                        </span>
                    }
                </span>
                <span className="d-flex flex-wrap">
                    {props.spellGroup.list && props.spellGroup.list.map((spellListItem, index2)=>{return(
                        <span className="d-flex" key={"spellGroup-"+props.index+"-spell-"+index2+"-view"}>
                            <SpellItemComponent 
                                
                                editMode={props.editMode}
                                isNewSpell={false}
                                spellGroup={props.spellGroup}
                                spell={props.spellGroup.list[index2]}
                                updateSpell={(spell: Spell)=>{}}
                                deleteSpell={()=>{}}
                            />
                        
                            {props.spellGroup.hasSlotsEach &&
                            <span className="input-group" style={{width: "114px", height: "40px"}}>
                                <input 
                                    value={spellListItem.remainingSlots}
                                    type="number"
                                    className='form-control'
                                    // style={{width: "70px", height: "40px"}}
                                    onChange={e => {
                                        let value = parseInt(e.target.value);
                                        if (value >= 0 && value <= props.spellGroup.maxSlots){
                                            spellListItem.remainingSlots = value;
                                            props.updateSpellGroup(props.spellGroup);
                                        }
                                    }}
                                ></input>
                                <span 
                                    // style={{width: "40px", height: "40px"}} 
                                    className="input-group-text"
                                >/&nbsp;{props.spellGroup.maxSlots}</span>
                            </span>}
                        </span>
                    )})}
                </span>
            </div>
        </div>}
        
    </>)
}
export default SpellGroupComponent;